<template>
  <div class="dashboard-top-right bg-light p-2">
    <div class="text-bold">Domestik VS Impor</div>
    <div style="display: flex; height: 80%; width: 100%; overflow-x: auto" v-if="realisasiBelanja">
      <div class="doughnat-container" v-for="(label, index) in labels" :key="index">
        <div class="text-bold text-center">{{ label }}</div>
        <pie-chart :chartData="chart[`chartData${index}`]" :options="chart[`chartOptions`]"
          :styles="{ height: '75%' }" />
        <div class="chart-text-center">
          {{ chart[`chartData${index}`]['datasets'][0]['data'][0] }}% |
          {{ chart[`chartData${index}`]['datasets'][0]['data'][1] }}%
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    PieChart: () => import('@/components/chart/dashboard/pie-chart.vue'),
  },
  data() {
    return {
      labels: [],
      chart: {
        chartData0: {
          labels: ['Domestik', 'Impor'],
          datasets: [
            {
              backgroundColor: ['red', 'pink'],
              data: [54, 46],
            },
          ],
        },

        chartData1: {
          labels: ['Domestik', 'Impor'],
          datasets: [
            {
              backgroundColor: ['red', 'pink'],
              data: [100, 0],
            },
          ],
        },

        chartData2: {
          labels: ['Domestik', 'Impor'],
          datasets: [
            {
              backgroundColor: ['red', 'pink'],
              data: [100, 0],
            },
          ],
        },

        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
            position: 'bottom',
            labels: {
              fontSize: 10,
              boxWidth: 12,
            },
          },
        },
      },
    }
  },
  computed: {
    realisasiBelanja() {
      let data = this.$store.state.tkdnStore.realisasiBelanja
      this.convertData(data)

      return data
    },
  },
  methods: {
    convertData(data) {
      if (data && data.length > 0) {
        let years = {}
        data.forEach(item => {
          if (years[`${item['YEAR']}`] == undefined) {
            years[`${item['YEAR']}`] = {
              domestik: {
                value: item['REG'] == 'domestik' ? item['VALUE_LC'] : 0,
              },
              impor: {
                value: item['REG'] == 'import' ? item['VALUE_LC'] : 0,
              },
            }
          } else {
            years[`${item['YEAR']}`] = {
              domestik: {
                value:
                  item['REG'] == 'domestik'
                    ? item['VALUE_LC']
                    : years[`${item['YEAR']}`]['domestik']['value'],
              },
              impor: {
                value:
                  item['REG'] == 'import'
                    ? item['VALUE_LC']
                    : years[`${item['YEAR']}`]['impor']['value'],
              },
            }
          }
        })

        let labels = Object.keys(years)

        for (let i in labels) {
          this.chart = {
            ...this.chart,
            [`chartData${i}`]: {
              labels: ['Domestik', 'Impor'],
              datasets: [
                {
                  backgroundColor: ['red', 'pink'],
                  data: [
                    this.convertPercent(
                      years[labels[i]]['domestik']['value'],
                      years[labels[i]]['impor']['value']
                    ).domestik,
                    this.convertPercent(
                      years[labels[i]]['domestik']['value'],
                      years[labels[i]]['impor']['value']
                    ).impor,
                  ],
                },
              ],
            },
          }
          // this.chart[`chartData${i}`]['datasets'][0] = {
          //   backgroundColor: ['red', 'pink'],
          //   data: [
          //     this.convertPercent(
          //       years[labels[i]]['domestik']['value'],
          //       years[labels[i]]['impor']['value']
          //     ).domestik,
          //     this.convertPercent(
          //       years[labels[i]]['domestik']['value'],
          //       years[labels[i]]['impor']['value']
          //     ).impor,
          //   ],
          // }
        }
        this.labels = labels
      } else {
        this.labels = []
        this.chart = {
          chartData0: {
            labels: [],
            datasets: [
              {
                backgroundColor: [],
                data: [],
              },
            ],
          },

          chartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                fontSize: 10,
                boxWidth: 12,
              },
            },
          },
        }
      }
    },
    convertPercent(domestik, impor) {
      let totalReg = Number(domestik) + Number(impor)

      return {
        domestik: Math.round((domestik / totalReg) * 100),
        impor: Math.round((impor / totalReg) * 100),
      }
    },
  },
}
</script>
<style scoped>
.doughnat-container {
  width: 33%;
  height: 100%;
  position: relative;
}

.chart-text-center {
  position: absolute;
  top: 53%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 8px;
}
</style>
